import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import EditStudentForm from "../Forms/EditStudentForm";
class EditStudent extends React.Component {
  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <ModalHeader>Uppdatera student</ModalHeader>
        <ModalBody>
          <EditStudentForm
            reloadStudents={this.props.updateStudents}
            dismissModal={this.props.toggle}
            student={this.props.student}
            classes={this.props.classes}
            refreshStudent={this.props.refreshStudent}
          />
        </ModalBody>
      </Modal>
    );
  }
}

export default EditStudent;
